// extracted by mini-css-extract-plugin
export var imageText = "styles-module--imageText--ea3b7";
export var imageTextImage = "styles-module--imageTextImage--7b2c6";
export var imageTextImageReverse = "styles-module--imageTextImageReverse--92a8f";
export var imageTextInner = "styles-module--imageTextInner--12aee";
export var imageTextParagraph = "styles-module--imageTextParagraph--85419";